var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radioChecked"},[(_vm.isChecked)?_c('checkIcon',{staticClass:"radioChecked__icon radioChecked__icon--checked"}):_c('unCheckIcon',{staticClass:"radioChecked__icon radioChecked__icon--unchecked"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }